import React from "react";
import "../styles/Clients.scss";
import Header from "./Header";
import Footer from "./Footer";

class Clients extends React.Component {
  render() {
    return (
      <div>
        <Header />
        <div className="container clients">
          <h1 className="heading serif-font">Clients</h1>

          <div className="client-list">
            <p>
              <img
                src={process.env.PUBLIC_URL + "/images/clients/esteelauder.jpg"}
                alt="Estée Lauder"
              />
            </p>
            <p>
              <img
                src={process.env.PUBLIC_URL + "/images/clients/google.jpg"}
                alt="Google"
              />
            </p>
            <p>
              <img
                src={
                  process.env.PUBLIC_URL + "/images/clients/lancomeparis.jpg"
                }
                alt="Lancôme Paris"
              />
            </p>
            <p>
              <img
                src={process.env.PUBLIC_URL + "/images/clients/hbo.jpg"}
                alt="HBO"
              />
            </p>
            <p>
              <img
                src={
                  process.env.PUBLIC_URL + "/images/clients/bottegaveneta.jpg"
                }
                alt="Bottega Veneta"
              />
            </p>
            <p>
              <img
                src={process.env.PUBLIC_URL + "/images/clients/givenchy.jpg"}
                alt="Givenchy"
              />
            </p>
            <p>
              <img
                src={process.env.PUBLIC_URL + "/images/clients/numero.jpg"}
                alt="Numéro"
              />
            </p>
            <p>
              <img
                src={process.env.PUBLIC_URL + "/images/clients/vogue.jpg"}
                alt="Vogue"
              />
            </p>
            <p>
              <img
                src={process.env.PUBLIC_URL + "/images/clients/interview.jpg"}
                alt="Interview"
              />
            </p>
            <p>
              <img
                src={process.env.PUBLIC_URL + "/images/clients/calvinklein.jpg"}
                alt="Calvin Klein"
              />
            </p>
            <p>
              <img
                src={
                  process.env.PUBLIC_URL +
                  "/images/clients/yvessaintlaurent.jpg"
                }
                alt="Yves Saint Laurent"
              />
            </p>
            <p>
              <img
                src={process.env.PUBLIC_URL + "/images/clients/handm.jpg"}
                alt="H&amp;M"
              />
            </p>
            <p>
              <img
                src={process.env.PUBLIC_URL + "/images/clients/celine.jpg"}
                alt="Céline"
              />
            </p>
            <p>
              <img
                src={process.env.PUBLIC_URL + "/images/clients/reebok.jpg"}
                alt="Reebok"
              />
            </p>
            <p>
              <img
                src={
                  process.env.PUBLIC_URL + "/images/clients/bananarepublic.jpg"
                }
                alt="Banana Republic"
              />
            </p>
            <p>
              <img
                src={process.env.PUBLIC_URL + "/images/clients/lloydandco.jpg"}
                alt="Lloyd &amp; Co"
              />
            </p>
            <p>
              <img
                src={process.env.PUBLIC_URL + "/images/clients/mother.jpg"}
                alt="Mother"
              />
            </p>
            <p>
              <img
                src={process.env.PUBLIC_URL + "/images/clients/vmagazine.jpg"}
                alt="V Magazine"
              />
            </p>
            <p>
              <img
                src={process.env.PUBLIC_URL + "/images/clients/greynewyork.jpg"}
                alt="Grey New York"
              />
            </p>
            <p>
              <img
                src={process.env.PUBLIC_URL + "/images/clients/wmagazine.jpg"}
                alt="W Magazine"
              />
            </p>
            <p>
              <img
                src={process.env.PUBLIC_URL + "/images/clients/nike.jpg"}
                alt="Nike"
              />
            </p>
            <p>
              <img
                src={process.env.PUBLIC_URL + "/images/clients/target.jpg"}
                alt="Target"
              />
            </p>
            <p>
              <img
                src={process.env.PUBLIC_URL + "/images/clients/valentino.jpg"}
                alt="Valentino"
              />
            </p>
            <p>
              <img
                src={
                  process.env.PUBLIC_URL + "/images/clients/tommyhilfiger.jpg"
                }
                alt="Tommy Hilfiger"
              />
            </p>
            <p>
              <img
                src={process.env.PUBLIC_URL + "/images/clients/ogilvy.jpg"}
                alt="Ogilvy"
              />
            </p>
            <p>
              <img
                src={process.env.PUBLIC_URL + "/images/clients/airparis.jpg"}
                alt="Air Paris"
              />
            </p>
            <p>
              <img
                src={process.env.PUBLIC_URL + "/images/clients/samsung.jpg"}
                alt="Samsung"
              />
            </p>
            <p>
              <img
                src={process.env.PUBLIC_URL + "/images/clients/prada.jpg"}
                alt="Prada"
              />
            </p>
            <p>
              <img
                src={process.env.PUBLIC_URL + "/images/clients/lorealluxe.jpg"}
                alt="L'Oreal Luxe"
              />
            </p>
            <p>
              <img
                src={process.env.PUBLIC_URL + "/images/clients/hugoboss.jpg"}
                alt="Hugo Boss"
              />
            </p>
            <p>
              <img
                src={process.env.PUBLIC_URL + "/images/clients/lanvinparis.jpg"}
                alt="Lanvin Paris"
              />
            </p>
            <p>
              <img
                src={process.env.PUBLIC_URL + "/images/clients/rolex.jpg"}
                alt="Rolex"
              />
            </p>
            <p>
              <img
                src={
                  process.env.PUBLIC_URL +
                  "/images/clients/wallstreetjournal.jpg"
                }
                alt="The Wall Street Journal Magazine"
              />
            </p>
            <p>
              <img
                src={
                  process.env.PUBLIC_URL +
                  "/images/clients/lairdandpartners.jpg"
                }
                alt="Laird + Partners"
              />
            </p>
            <p>
              <img
                src={
                  process.env.PUBLIC_URL + "/images/clients/kidscreative.jpg"
                }
                alt="Kids Creative"
              />
            </p>
            <p>
              <img
                src={
                  process.env.PUBLIC_URL +
                  "/images/clients/youngandrepublican.jpg"
                }
                alt="Young &amp; Republican"
              />
            </p>
            <p>
              <img
                src={process.env.PUBLIC_URL + "/images/clients/mulberry.jpg"}
                alt="Mulberry"
              />
            </p>
            <p>
              <img
                src={process.env.PUBLIC_URL + "/images/clients/dkny.jpg"}
                alt="DKNY"
              />
            </p>
            <p>
              <img
                src={process.env.PUBLIC_URL + "/images/clients/tomford.jpg"}
                alt="Tom Ford"
              />
            </p>
            <p>
              <img
                src={process.env.PUBLIC_URL + "/images/clients/tmagazine.jpg"}
                alt="T Magazine"
              />
            </p>
            <p>
              <img
                src={process.env.PUBLIC_URL + "/images/clients/love.jpg"}
                alt="Love"
              />
            </p>
            <p>
              <img
                src={process.env.PUBLIC_URL + "/images/clients/hermesparis.jpg"}
                alt="Hermès Paris"
              />
            </p>
            <p>
              <img
                src={
                  process.env.PUBLIC_URL +
                  "/images/clients/baronandbaroninc.jpg"
                }
                alt="Baron &amp; Baron, Inc"
              />
            </p>
            <p>
              <img
                src={process.env.PUBLIC_URL + "/images/clients/bbdo.jpg"}
                alt="BBDO"
              />
            </p>
            <p>
              <img
                src={process.env.PUBLIC_URL + "/images/clients/publicis.jpg"}
                alt="Publicis"
              />
            </p>
            <p>
              <img
                src={process.env.PUBLIC_URL + "/images/clients/dior.jpg"}
                alt="Dior"
              />
            </p>
            <p>
              <img
                src={process.env.PUBLIC_URL + "/images/clients/laperla.jpg"}
                alt="La Perla"
              />
            </p>
            <p>
              <img
                src={
                  process.env.PUBLIC_URL +
                  "/images/clients/dianevonfurstenberg.jpg"
                }
                alt="Dian Von Furtsenberg"
              />
            </p>
            <p>
              <img
                src={process.env.PUBLIC_URL + "/images/clients/oldnavy.jpg"}
                alt="Old Navy"
              />
            </p>
            <p>
              <img
                src={process.env.PUBLIC_URL + "/images/clients/balenciaga.jpg"}
                alt="Balenciaga"
              />
            </p>
            <p>
              <img
                src={process.env.PUBLIC_URL + "/images/clients/uniqlo.jpg"}
                alt="Uniqlo"
              />
            </p>
            <p>
              <img
                src={process.env.PUBLIC_URL + "/images/clients/donnakaran.jpg"}
                alt="Donna Karan"
              />
            </p>
            <p>
              <img
                src={process.env.PUBLIC_URL + "/images/clients/mango.jpg"}
                alt="Mango"
              />
            </p>
            <p>
              <img
                src={
                  process.env.PUBLIC_URL + "/images/clients/giorgioarmani.jpg"
                }
                alt="Giorgio Armani"
              />
            </p>
          </div>
          <div className="clients-text-list">
            <div className="one-third">
              <p>ADOLFO DOMINGUEZ</p>
              <p>AKRIS</p>
              <p>A.P.C.</p>
              <p>ALBION</p>
              <p>ANA KHOURI</p>
              <p>APPLE</p>
              <p>ARMANI</p>
              <p>ASSEMBLY</p>
              <p>AVON</p>
              <p>AZZEDINE ALAIA</p>
              <p>BALLY</p>
              <p>BALMAIN</p>
              <p>BARNEYS NEW YORK</p>
              <p>BENETTON</p>
              <p>BERGDORF GOODMAN</p>
              <p>BLUMARINE</p>
              <p>BOBBI BROWN</p>
              <p>BORBONESSE</p>
              <p>BRIONI</p>
              <p>CALVIN KLEIN</p>
              <p>CAMILLA &amp; MARC</p>
              <p>CARTIER</p>
              <p>CARRERA</p>
              <p>CASIO</p>
              <p>CELINE</p>
              <p>CERRUTI</p>
              <p>CHANEL</p>
              <p>CHANTELLE</p>
              <p>CHLOE</p>
              <p>CHRISTOPHE LEMAIRE</p>
              <p>CLARINS</p>
              <p>COMPTOIR DES COTONNIERS</p>
              <p>COTY</p>
              <p>COVERGIRL</p>
              <p>DIESEL</p>
              <p>DIOR</p>
              <p>DSQUARED</p>
              <p>ELIE SAAB</p>
              <p>ENERGIE</p>
              <p>ENZO</p>
              <p>ERES</p>
              <p>ERMENEGILDO ZEGNA</p>
              <p>ESCADA</p>
              <p>ESTEE LAUDER</p>
              <p>EVAN YURMAN</p>
              <p>EXPRESS</p>
            </div>
            <div className="one-third">
              <p>FERRAGAMO</p>
              <p>FOSSIL</p>
              <p>GIUSEPPE ZANOTTI</p>
              <p>GIVAUDAN</p>
              <p>GIVENCHY</p>
              <p>GUCCI</p>
              <p>GUERLAIN</p>
              <p>H&amp;M</p>
              <p>HAIDER ACKERMANN</p>
              <p>HELMUT LANG</p>
              <p>HERMES</p>
              <p>HOGAN</p>
              <p>HOLT &amp; RENFREW</p>
              <p>HOOD BY AIR</p>
              <p>ICEBERG</p>
              <p>ISABEL MARANT</p>
              <p>JASON WU</p>
              <p>JEAN PAUL GAULTIER</p>
              <p>JIL SANDER</p>
              <p>JIMMY CHOO</p>
              <p>JONES NEW YORK</p>
              <p>JULIEN DAVID</p>
              <p>JUST CAVALLI</p>
              <p>KENZO</p>
              <p>KVADRAT</p>
              <p>L'OREAL</p>
              <p>LACOSTE</p>
              <p>LANCEL</p>
              <p>LANCOME</p>
              <p>LANVIN</p>
              <p>LAURENT PERRIER</p>
              <p>LE BON MARCHE</p>
              <p>LISA PERRY</p>
              <p>LOUIS VUITTON</p>
              <p>MACY'S</p>
              <p>MAJE</p>
              <p>MANGO</p>
              <p>MARCO POLO</p>
              <p>MARKS AND SPENCER</p>
              <p>MATCHESFASHION.COM</p>
              <p>MAX FACTOR</p>
              <p>MAX MARA</p>
              <p>MAYBELLINE</p>
              <p>MIHARA YASUHIRO</p>
              <p>MISS SIXTY</p>
              <p>MISSONI</p>
            </div>
            <div className="one-third">
              <p>MIU MIU</p>
              <p>MO&amp;CO</p>
              <p>MOET &amp; CHANDON</p>
              <p>MR PORTER</p>
              <p>MUMM</p>
              <p>NICHOLAS KIRKWOOD</p>
              <p>NIKE</p>
              <p>NISSAN</p>
              <p>NORDSTROM</p>
              <p>OLYMPIA LE TAN</p>
              <p>ORLEY</p>
              <p>PACO RABANNE</p>
              <p>PATRIK ERVELL</p>
              <p>PAUL &amp; JOE</p>
              <p>PENNYBLACK</p>
              <p>PEPE JEANS</p>
              <p>PERONI</p>
              <p>PHILOSOPHY</p>
              <p>PIAGET</p>
              <p>POLLINI</p>
              <p>PRADA</p>
              <p>PUCCI</p>
              <p>ROCHAS</p>
              <p>RAMI AL ALI</p>
              <p>SACAI</p>
              <p>SANDRO</p>
              <p>SHANGAI TANG</p>
              <p>SIMPLE COSMETICS</p>
              <p>SISLEY</p>
              <p>SONY ERICSSON</p>
              <p>SONYA RYKIEL</p>
              <p>SWAROVSKI</p>
              <p>TAMARA MELLON</p>
              <p>TASSO ELBA</p>
              <p>THALE BLANC</p>
              <p>THE ROW</p>
              <p>THEORY</p>
              <p>UNIQLO</p>
              <p>VALENTINO</p>
              <p>VIOLET GREY</p>
              <p>VPL</p>
              <p>WOO YOUG MI</p>
              <p>YVES SAINT LAURENT</p>
              <p>ZANOTTI</p>
              <p>ZARA</p>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    );
  }
}

export default Clients;
